import { supo } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { Dispatch } from 'redux';
import { State } from '../reducers';
import { Activity, FeedOptions } from '../interfaces/Social';
import { getToken } from '../selectors/user';
import { getFeed } from '../selectors/feed';

export const fetchFeed = (filter: Partial<FeedOptions>, limit = 20, offset = 0) => {
  const key = JSON.stringify(filter);
  return async (dispatch: Dispatch, getState: () => State) => {
    const token = getToken(getState());
    const { userId, ...rest } = filter;
    try {
      if (offset === 0 && getFeed(getState(), filter).length === 0) {
        dispatch({
          type: ActionTypes.FETCH_FEED_REQUEST,
          payload: { key }
        });
      }
      const { data: activities }: { data: Activity[] } = await supo.get(`/feed/${userId}`, {
        params: { ...rest, limit, offset },
        headers: { Authorization: `Bearer ${token}` }
      });
      return dispatch({
        type: ActionTypes.FETCH_FEED_SUCCESS,
        payload: { activities, key }
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return dispatch({
          type: ActionTypes.FETCH_FEED_NOT_FOUND,
          payload: { key },
          error
        });
      }
      return dispatch({
        type: ActionTypes.FETCH_FEED_ERROR,
        payload: { key },
        error
      });
    }
  };
};
